export type GroupInput = {
  key: string;
  determining: boolean;
  title: string;
};

export default (groups) => {
  let result: GroupInput[] = [];


  console.log('//== extractring from these', groups)

  groups.forEach((group, index, self) => {
    // Get the inputfields fromt the main attributes
    // Every related attribute's name will start with input_field_
    const inputFields = group.attributes.filter(
      (attr) => attr.identifier.indexOf("input_field_") > -1
    );

    // Go through to the inputFields
    inputFields.forEach((field) => {
      // Checking that the current item's id was represented already in the result
      const currentIndex = result.findIndex(
        (item) => item.key === field.identifier
      );

      // Checking that the current item is 'determining' or not
      const isDetermining =
        field.values.findIndex((item) => item.value === "determining_field") >
        -1;

      // Create a blank variable for for the new entry
      let newEntry: GroupInput;

      // If the current element is not represented in the result, create a newEntry
      if (currentIndex === -1)
        newEntry = { key: field.identifier, title: field.title, determining: false };

      // If the current element is 'determining', update it
      if (isDetermining) {
        newEntry.determining = true;
      }

      // If the new entry is valid, push it to the result
      if (newEntry) result.push(newEntry);
    });
  });

  return result;
};
